import React from "react";
import Drawer from "../../Common/Drawer/Drawer";
import { toast } from "react-toastify";
import jobService from "../../../Services/JobService";
import { trackPromise } from "react-promise-tracker";

class DraftJobCancelDrawer extends React.Component {
  state = {
    showJobCancelDrawer: false
  };

  render() {
    const drawer = this.createDrawer();

    return (
      <>
        <button className="edit-button with-left-margin my-sm-0 mb-3" onClick={this.toggleJobCancelDrawer} style={{ lineHeight: "18px" }}>
          <span className="button-label">Cancel</span>
        </button>
        {drawer}
      </>
    );
  }

  createDrawer = () => {
    const header = this.createJobCancelHeader();
    const body = this.createJobCancelBody();
    const footer = this.createJobCancelFooter();

    return (
      <Drawer
        size={"md"}
        open={this.state.showJobCancelDrawer}
        header={header}
        body={body}
        footer={footer}
      />
    );
  };

  createJobCancelHeader = () => {
    return (
      <>
        <h2 className="d-flex align-items-center">Cancel Job</h2>
        <div className="panel-header-actions">
          <button
            className="action-btn panel-close"
            onClick={this.toggleJobCancelDrawer}
          >
            <i className="ba-icn ba-icn-close"></i>
          </button>
        </div>
      </>
    );
  };

  createJobCancelBody = () => {
    return (
      <div className="panel-body">
        <div className="row">
          <div className="col-sm-12">
            <div className="form-group">
              <label className="d-flex">Are you sure you want to cancel this maintenance request?</label>
            </div>
          </div>
        </div>
      </div>
    );
  };

  createJobCancelFooter = () => {
    return (
      <div className="card-actions">
        <button onClick={this.onClickJobCancel}>
          <i className="ba-icn ba-icn-ok"></i> Yes
        </button>
        <button className="more-actions" onClick={this.toggleJobCancelDrawer}>
          No
        </button>
      </div>
    );
  };

  onClickJobCancel = () => {
    trackPromise(
      jobService.CancelJob(this.props.jobId).then(response => {
        if (response) {
          toast.success("The maintenance request has been successfully cancelled.", {
            position: toast.POSITION.BOTTOM_RIGHT
          });

         setTimeout(() => {
            this.toggleJobCancelDrawer();
            if (this.props.toggleDrawer) {
            this.props.toggleDrawer(true);
            }
          }, 6000);
        } else {
          toast.error("Error occurred. Please try again.", {
            position: toast.POSITION.BOTTOM_RIGHT
          });
        }
      }).catch(error => {
        toast.error("Error occurred. Please try again.", {
          position: toast.POSITION.BOTTOM_RIGHT
        });
      })
    );
  };

  toggleJobCancelDrawer = () => {
    this.setState(state => ({
      showJobCancelDrawer: !state.showJobCancelDrawer
    }));
  };
}

export default DraftJobCancelDrawer;